import { IApplicationState } from '../../types/redux';

export const selectIsFindAgentTabEnabled = (state: IApplicationState) => state.featureToggles.isFindAgentTabEnabled;
